<div [height]="5"></div>
<table cols="2" cellspacing="0" cellpadding="0">
  <tr class="row">
    <td colspan="2" class="text">
      Your current Brixx subscriptions includes
      <span class="text-red">{{
        licenseData ? licenseData.maxPlans : ""
      }}</span>
      plan(s)
    </td>
  </tr>
  <tr class="line">
    <td colspan="2"></td>
    <td></td>
  </tr>
  <tr class="row">
    <td colspan="2" class="text">
      You are currently using
      <span class="text-red">{{ activePlansCount }}</span> out of your
      <span class="text-red">{{
        licenseData ? licenseData.maxPlans : ""
      }}</span>
      plan(s)
    </td>
  </tr>
  <tr class="line">
    <td colspan="2"></td>
    <td></td>
  </tr>

  <ng-container *ngIf="initialSubscriptionType == 'Monthly'">
    <tr class="row">
      <td colspan="2" class="text-bold">
        <div class="switcher-div">
          <slide-switcher
            label="Switch to annual billing frequency (Save 20%)"
            [labelClass]="'textBold'"            
            [height]="20"
            [(ngModel)]="switchToAnnual"
            (switch)="onAnnualSwitched($event)"
            [testId]="'BillingFrequencySwitcher'"
          >
          </slide-switcher>
        </div>
      </td>
    </tr>
    <tr class="line">
      <td colspan="2"></td>
      <td></td>
    </tr>
  </ng-container>

  <tr class="mini-row"></tr>
  <tr class="row">
    <td class="text" style="width: 50%">
      Please select your new<br /><b>total number</b> of plans
    </td>
    <td>
      <div style="display: flex; justify-content: center">
        <combo
          #plansCountCombo
          style="margin-left: 10px"
          hint="Choose plans count"
          i18n-hint
          [ComboData]="brixxSinglePlansCountItems"
          [ngModel]="selectedPlansItemId"
          [height]="30"
          [width]="162"
          [label]="''"
          [backgroundColor]="'white'"
          [inputTextClass]="'large-field'"
          [showImg]="false"
          (changeCaller)="changeSinglePlansCount($event)"
          [testId]="'plansCountCombo'"
          [listMaxHeight]="260"
          [disabled]="maxSlotsReached"
        >
        </combo
        ><br />
      </div>
    </td>
  </tr>
  <tr class="mini-row"></tr>
  <tr class="row">
    <td colspan="2" class="text">
      Total to pay:
        <span class="text-red" data-testid="TotalToPay">{{ currentCurSymbol }} {{ proRataPrice | number : "0.2" }}</span>
        <br />
        <span style="font-size: 13px">*Price excludes local taxes</span>
        <br />
        <span style="font-size: 13px"
        >*Pro-rated amount will be visible on next page</span
      >
    </td>
  </tr>
  <tr class="mini-row"></tr>
  <tr class="row">
    <td colspan="2" class="text">
      <simple-btn
        (click)="onBuyPlanSlots()"
        style="margin: auto"
        [width]="140"
        [disabled]="maxSlotsReached"
        [backgroundFillCls]="'o2Background'"
        [hoverFillCls]="'o1Background'"
        [boxShadowCls]="'primary-shadow'"
        i18n-text
        text="Proceed to Payment"
        [textCls]="'large-btn-text'"
        [height]="40"
        [cornerRadius]="50"
        [horizontalPadding]="20"
        data-testid="ProceedToPaymentBtn"
      >
      </simple-btn>
    </td>
  </tr>
</table>
<div [height]="30"></div>
